































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { getDaysInMonth } from '@/lib/helpers/common.helper';
import { ILogworkData, ILogworkWithProject } from '@/lib/interfaces';

@Component
export default class LogworkTable extends Vue {
  @Prop() private data!: { projectGroup: ILogworkWithProject[]; dateGroup: ILogworkData[] };
  @Prop() private day!: number;
  @Prop() private month!: number;
  @Prop() private year!: number;

  private get columnTitles(): number[] {
    return getDaysInMonth(this.month, this.year);
  }

  /** Уникальные проекты */
  private get rowTitles(): Array<ILogworkWithProject['project']> {
    if (!this.data) {
      return [];
    }
    const existsProjects = new Set<string>();
    const res: Array<ILogworkWithProject['project']> = [];
    const { projectGroup } = this.data;
    projectGroup.forEach((d) => {
      if (!existsProjects.has(d.project._id)) {
        res.push(d.project);
        existsProjects.add(d.project._id);
      }
    });
    return res;
  }

  private get allAmount() {
    return this.data.dateGroup.reduce((sum, d) => (sum += d.totalAmount), 0);
  }

  /** Выходной ли день? */
  private isWeekend(day: number): boolean {
    const dayNumber = new Date(this.year, this.month, day).getDay();
    return dayNumber === 6 || dayNumber === 0;
  }

  /** Текущий ли день? */
  private isCurrent(day: number): boolean {
    const currentDay = new Date().getDate();
    return currentDay === day;
  }

  private getAmountAtDay(day: number, projectId?: string): number {
    let foundGroup: ILogworkData[] | ILogworkWithProject[];
    if (projectId) {
      foundGroup = this.data.projectGroup;
    } else {
      foundGroup = this.data.dateGroup;
    }
    /* tslint:disable */
    for (let i = 0; i < foundGroup.length; i++) {
      const element = foundGroup[i];
      if (element.day === day) {
        if (!projectId) {
          return element.totalAmount;
        } else if ((element as ILogworkWithProject).project._id === projectId) {
          return element.totalAmount;
        }
      }
    }
    return 0;
  }
}
